<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="600">
      <v-form ref="AddStrategicPriority" lazy-validation>
        <v-card rounded="lg" elevation="3">
          <!-- HEADER -->
          <v-card-title class="dialog-header px-6 py-4">
            <span class="headline font-weight-medium">
              {{ action }}
              {{ tab == 1 ? "Strategic Plan" : "SUC Leveling" }}
            </span>
            <v-spacer />
            <v-btn icon @click="closeD">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider />

          <!-- BODY -->
          <v-card-text class="py-6">
            <v-container fluid>
              <v-row dense>
                <!-- STRATEGIC TYPE -->
                <!-- <v-col cols="12">
                  <v-card outlined class="pa-4 rounded-lg">
                    <div class="subtitle-1 font-weight-medium mb-2">
                      Strategic Planning Type
                    </div>
                    <v-radio-group
                      v-model="strat_type"
                      row
                      class="mt-1 mx-10"
                      mandatory
                      readonly
                    >
                      <v-radio label="SDP" value="SDP" />
                      <v-spacer></v-spacer>
                      <v-radio label="SUC LEVELING" value="SUC" />
                    </v-radio-group>
                  </v-card>
                </v-col> -->

                <!-- TITLE -->
                <v-col cols="12" class="mt-5">
                  <v-textarea
                    v-model="title"
                    label="Title"
                    outlined
                    dense
                    auto-grow
                    rows="1"
                    :rules="[formRules.required]"
                    color="green"
                  />
                </v-col>

                <!-- YEAR FROM -->
                <v-col cols="12" md="6" class="mb-n1">
                  <v-autocomplete
                    v-model="dateFrom"
                    :items="yearListFrom"
                    item-text="description"
                    item-value="id"
                    label="Year From"
                    outlined
                    dense
                    :readonly="action == 'Update'"
                    color="green"
                    @change="onChangeDateFrom"
                  />
                </v-col>

                <!-- YEAR TO (SDP) -->
                <v-col cols="12" md="6" v-if="strat_type === 'SDP'">
                  <v-text-field
                    v-model="dateTo"
                    label="Year To"
                    outlined
                    dense
                    readonly
                    :rules="[formRules.required]"
                    color="green"
                  />
                </v-col>

                <!-- YEAR TO (NON-SDP) -->
                <v-col cols="12" md="6" v-else>
                  <v-autocomplete
                    v-model="dateTo"
                    :items="yearListFrom"
                    item-text="description"
                    item-value="id"
                    label="Year To"
                    :readonly="action == 'Update'"
                    outlined
                    dense
                    color="green"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider />

          <!-- ACTIONS -->
          <v-card-actions class="px-6 py-4">
            <v-spacer />

            <v-btn outlined color="red" @click="closeD">
              <v-icon left>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              class="white--text ml-2"
              v-if="action === 'Add'"
              @click="addnew()"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Add
            </v-btn>

            <v-btn
              color="green darken-1"
              class="white--text ml-2"
              v-if="action === 'Update'"
              @click="update()"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- MESSAGE -->
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    action: null,
    tab: null,
  },

  data() {
    return {
      id: null,
      dialog: false,
      strat_type: "",
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      yearListFrom: [],
      period: null,
      assessed_by_user: null,
      final_rating_by_user: null,
      dateFrom: null,
      dateTo: null,
      minimumRequired: null,
      periodList: [
        {
          id: 1,
          description: "January to June",
        },
        {
          id: 2,
          description: "July to December",
        },
        {
          id: 3,
          description: "January to December",
        },
      ],
      title: null,
      presidentUser: null,
      isHeadPresident: null,
      usersList: [],
      recommendingUsersList: [],
    };
  },
  watch: {
    data: {
      handler(data) {
        console.log("Year Form", data.yearFrom);
        this.dialog = true;
        this.loadYearFrom();
        this.getUsers();

        if (data.id) {
          this.period = data.period;
          this.strat_type = data.strat_type;
          this.id = data.id;
          this.year = data.year;
          this.title = data.title;
          this.dateFrom = data.yearFrom;
          this.dateTo = data.yearTo;
        } else {
          this.period = null;
          this.strat_type = this.tab == 1 ? "SDP" : "SUC";
          this.id = null;
          this.year = null;
          this.title = data.title;
          this.dateFrom = data.yearFrom;
          this.dateTo = data.yearTo;
        }
      },

      deep: true,
    },
  },

  methods: {
    initialize() {},

    getUsers() {
      this.axiosCall("/user-details/getDeanDirAboveUsers", "GET").then(
        (res) => {
          let data = res.data;
          data.forEach((element, i) => {
            data[i].name = this.toTitleCase(element.name);
          });
          this.usersList = data;
          // console.log(res.data);
        },
      );
    },

    loadYearFrom() {
      let d = new Date();

      let yr = d.getFullYear();

      for (let i = yr; i < yr + 10; i++) {
        this.yearListFrom.push(i);
      }
    },
    onChangeDateFrom(data) {
      if (this.strat_type == "SDP") {
        this.dateTo = data + 4;
      }
    },

    closeD() {
      this.eventHub.$emit("closeStrategicPriority", false);
      this.dialog = false;
    },

    addnew() {
      if (this.$refs.AddStrategicPriority.validate()) {
        let data = {
          title: this.title,
          yearFrom: this.dateFrom,
          yearTo: this.dateTo,
          strat_type: this.strat_type,
        };
        // console.log(data);
        this.axiosCall("/strategic-planning", "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please fill-up all field please!";
      }
    },

    update() {
      if (this.$refs.AddStrategicPriority.validate()) {
        let data = {
          title: this.title,
          yearFrom: this.dateFrom,
          yearTo: this.dateTo,
          strat_type: this.strat_type,
        };

        this.axiosCall(
          "/strategic-planning/updateStrategicPlanning/" + this.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.dialog-header {
  background-color: #f5f7f9;
}
</style>
